export interface Signal {
  subscribe: (listener: () => void) => () => void;
  emit: () => void;
  reset: () => void;
}

export function createSignal(): Signal {
  const subscribers = new Set<() => void>();

  return {
    subscribe(listener: () => void): () => void {
      subscribers.add(listener);
      return () => subscribers.delete(listener);
    },
    emit(): void {
      subscribers.forEach((listener) => {
        try {
          listener();
        } catch (error) {
          console.error('signInRequired subscriber threw', error);
        }
      });
    },
    reset(): void {
      subscribers.clear();
    },
  };
}

export const signInRequired = createSignal();
